module.exports = __webpack_public_path__ + "img/garden_cortado.83ab849a.png";